import {
  DocumentNode,
  LazyQueryResultTuple,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useLazyQuery,
} from '@apollo/client';

import { useAuth } from '../../contexts/AuthContext';

// NOTE: The signature of this hook mimics that of useQuery, so if useQuery changes we should also
// update this.
export function useRutilusLazyQuery<TData = any, TVariables extends OperationVariables = {}>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options: QueryHookOptions<TData, TVariables> = {},
): LazyQueryResultTuple<TData, TVariables> {
  const { getToken } = useAuth();
  const result = useLazyQuery(query, {
    ...options,
    context: { ...options.context, getAuthToken: getToken },
  });

  return result;
}
